import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'RedirectView',
  setup(__props) {

const route = useRoute();
const redirect = route.query.ref;

if (typeof redirect === "string") {
  window.location.href = redirect;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("p", null, "Redirecting..."))
}
}

})